import React, { useEffect } from "react";
import Styled from "styled-components";
import david from "../Images/david.jpg";

export default function KrishnaIyerChair() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div>
      <DIV>
        <BOX>
          <h1>Chancellor’s Chair Lectures</h1>

          <COLOR>
            <TOP>
              <p className="above">
                The Centre organised lectures by the Chancellor’s Chair
                professor of the University Dr. David Hunter for the M. Phil and
                Ph. D. research scholars attending course work programs and for
                the participants attending certificate program at the Centre.
                The lectures by Dr. Hunter were focused on dwelling into the
                various theories of ethics and philosophy and its significance
                in research generally and in
              </p>

              {/* <H3>Coordinator:</H3>{" "}
              <H4>Dr. Seema P. S., Associate Professor, SLS</H4> */}
            </TOP>
            <H4> Dr. David Hunter</H4>
            <img
              src={david}
              alt="image"
              style={{ height: "149px", width: "164px" }}
            ></img>
            <p>
              {" "}
              Dr. David Hunter is the senior Lecturer, Health and Medical
              Sciences Faculty Office, Faculty of Health and Medical Sciences,
              University of Adelaide, Australia. He is the Joint Editor in Chief
              of Research Ethics Forum, a book series published by Springer,
              Book Review Editor for Public Health Ethics, Advisory Board Member
              for the International Journal for Feminist Approaches to Bioethics
              and also the Coordinator of the Teaching Ethics stream of the
              Australasian Association of Bioethics and Health Law.
            </p>
          </COLOR>
        </BOX>
      </DIV>
    </div>
  );
}
const H3 = Styled.h3`
    font-family: PT Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:395px){
      font-size: 14px;
    }
   `;
const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color: #000000;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const DIV = Styled.div`
    background: #FAFAFA;
    display:flex ;
    justify-content:center;
    align-items: center;
    width:100%;`;

const BOX = Styled.div`
   
    width:85%;
    margin:50px auto;
    
    h1{
        font-family: Oswald;
        font-style: normal;
        font-weight: normal;
        font-size: 32px;
        font-weight:500;
        color: #E01E38;
        display:flex;
    }
    @media (max-width:660px){
        h1{
            font-size: 30px;
            }
    }
    @media (max-width:534px){
      margin:30px auto;
        h1{
         font-size: 28px;
         }
       }
       @media (max-width:395px){
        padding:16px;
        h1{
         font-size: 26px;
         }
`;
const COLOR = Styled.div`

    background: white;
    padding: 20px  40px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
    @media (max-width:368px){
        padding: 10px;
    }
`;

const TOP = Styled.div`
     p{
        font-family: PT Serif;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        color: #000000;
        text-align:justify;
        @media (max-width:640px){
            font-size: 18px;
          }
          @media (max-width:540px){
            font-size: 16px;
          }
        }
   
`;
